import React, { useContext, useEffect, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { signOut } from "../../../../context/auth/action";
import { ROUTES } from "../../../../routing/routes";
import { GlobalLoadingContext, IGlobalLoadingContext } from "../../../../providers/GlobalLoading";
import { AuthState } from "../../../../context/auth/auth/reducer";
import { useTranslation } from "react-i18next";
import { History } from "history";
import ProfileUserImage from "../../userImg/ProfileUserImage";
import { USER_ROLES } from "../../../../data/enums";
import _environment from "../../../../_environment/_environment";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {}

const NavUserInfo = ({ ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------

  // Reference to Redux store dispatch function: use it to dispatch actions.
  const dispatch = useDispatch();

  // Access to the history instance that you may use to navigate.
  let history = useHistory();

  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // Access to loading manager provider that you may use to show and hide global loading
  const { showGlobalLoading } = useContext<IGlobalLoadingContext>(GlobalLoadingContext);

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  const [mattermostNotification, setMattermostNotification] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { user } = useSelector(({ authReducer }: { authReducer: AuthState }) => {
    return authReducer;
  });

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  const logout = (): void => {
    showGlobalLoading();
    dispatch(signOut(history));
  };

  /**
   * Navigate to profile to enable mattermost account
   */
  const goToProfileChat = (): void => {
    history.push({
      pathname: ROUTES.PROFILE,
      search: "?section=chat",
    });
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[NavUserInfo] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[NavUserInfo] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------

  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  /**
   * This hook is called when user changes
   */
  useEffect(() => {
    if (!!user) {
      if (
        !user.mattermost?.username &&
        user.profile_completed &&
        user.role === USER_ROLES.VISITOR
      ) {
        setMattermostNotification(true);
      } else {
        setMattermostNotification(false);
      }
    }
  }, [user]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      <div className="nav-item dropdown no-arrow notifications">
        {!!mattermostNotification && <span className="counter">1</span>}
        <a
          className="nav-link dropdown-toggle"
          href="#"
          id="notificationsDropdown"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i className="fas fa-bell fa-sm fa-fw mr-2 text-gray-400"></i>
        </a>
        <div
          className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
          aria-labelledby="notificationsDropdown"
        >
          {!!mattermostNotification && (
            <div className="notification" onClick={goToProfileChat}>
              <i className="fas fa-comments"></i>
              <span>
                Hey {user?.firstname}, enable your <strong>chat account</strong> in your profile!
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="nav-item dropdown">
        <a
          className="nav-link dropdown-toggle"
          href="#"
          id="userDropdown"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span className="mr-2 d-none d-lg-inline username">{user?.firstname}</span>
          <ProfileUserImage />
        </a>
        <div
          className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
          aria-labelledby="userDropdown"
        >
          {user?.role === USER_ROLES.VISITOR && (
            <NavLink
              className="dropdown-item"
              activeClassName="font-weight-bold"
              to={ROUTES.PROFILE}
            >
              <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
              {t("nav.profile")}
            </NavLink>
          )}
          <div className="dropdown-divider"></div>
          <a className="dropdown-item" href="#" onClick={() => logout()}>
            <i className="fas fa-power-off fa-sm fa-fw mr-2 text-gray-400"></i>
            {t("nav.logout")}
          </a>
        </div>
      </div>
    </>
  );
};
export default NavUserInfo;
